import { useState,useEffect } from "react";
import {Navbar,Container, Nav} from "react-bootstrap";
import logo from '../assests/img/Manasvi.svg';
import navIcon1 from '../assests/img/nav-icon1.svg';
import navIcon2 from '../assests/img/nav-icon2.svg';
import navIcon3 from '../assests/img/nav-icon3.svg';

export const NavBar =() => {
    const[activeLink, setActiveLink] = useState('home');
    const[scrolled,setScrolled] =useState(false);
    
    useEffect(() => {
        const onScroll =() => {
            if(window.scrollY > 50){
                setScrolled(true);
            }else{
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);

        return () => window.addEventListener("scroll", onScroll);
    },[])

    const onUpdateActiveLink =(value) => {
        setActiveLink(value);
    }

    return (
        <Navbar expand="lg" className={scrolled ? "scrolled": ""}>
            <Container>
                <Navbar.Brand href="#home">
                    <img src ={logo}atl="logo"/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" >
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#home"className={activeLink=== 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                        <Nav.Link href="#skills"className={activeLink=== 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
                        <Nav.Link href="#projects"className={activeLink=== 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/manasvi-sri/"><img src={navIcon1}alt="Linkedin"/></a>
                            <a href="https://github.com/grimreapermanasvi"><img src={navIcon2}alt="GitHub"/></a>
                            <a href="https://leetcode.com/u/ManasviSrivastava/"><img src={navIcon3}alt="LeetCode"/></a>
                        </div>
                        <a href="https://www.linkedin.com/in/manasvi-sri/">
                        <button className="vvd" onClick={() => console.log('connect')}><span>Let's Connect </span></button>
                        </a>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}